<template>
    <div class="step" v-show="isSelected" :class="[{'is-selected': isSelected}, {'is-checked': isChecked}, {'is-valid': isValid}]">
		<slot></slot>
    </div>
</template>

<script>
    export default {
        props: {
            /**
             * Nome mostrado no menu lateral e é o identificador do 'step'/etapa
             */
            name: {
                type: String,
                required: true,
            },

            /**
             * Define o componente que está selecionado
             * Usado para deixar algum 'step'/etapa pré-selecionado
             */
            selected: {
                type: Boolean,
                default: false,
            },

            /**
             * Define se o 'step'/etapa está completo
             * semelhante a um componente html checkbox
             */
            checked: {
                type: Boolean,
                default: false,
            },

            /**
             * Define se o conteúdo do 'step' está valido (especialmento em caso de formulário)
             * se estiver válido o o componente avança para o próximo passo
             */
            valid: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                isSelected: false,
                isChecked: false
            }
        },

        computed: {
            isValid: {
                get() {
                    return this.valid
                },
                set(value) {
                    this.$emit('update:valid', value)
                }
            }
        },

        mounted() {
            this.isSelected = this.selected
            this.isChecked = this.checked
        },

        watch: {
            valid(newValue, oldValue) {
                if(newValue !== oldValue && newValue) this.$parent.$parent.$emit('is-valid', newValue)
            },
        }
    }
</script>